import ajax from "../../../authenticationSafeAjax";

export default function (values, dispatch) {
    return new Promise((resolve, reject) => {
        ajax({
            body: JSON.stringify(values),
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            url: "/disclosure/api/buyside-invitation"
        }, (statusCode, text, request) => {
        });
    });
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/portal/actions/submitVerifyEmail.js
 **/